module.exports = new __parcel__URL__("chat.06e18536.svg").toString();